import { Injectable, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { ZoomService } from './zoom.service';

@Injectable({
  providedIn: 'root',
})
export class RoutingLoaderService {
  private readonly router = inject(Router);
  private readonly _isLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _zoomService = inject(ZoomService);

  readonly isLoading$: Observable<boolean> = this._isLoading$.asObservable();

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        ),
        debounceTime(100)
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this._isLoading$.next(true);
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this._isLoading$.next(false);
        }

        if (event instanceof NavigationEnd) {
          // Small delay to ensure that the loading indicator is visible for very fast navigations
          this._isLoading$.next(false);
          setTimeout(() => {
            this._zoomService.applyCurrentZoomLevel();
          }, 500);
        }
      });
  }
}
